import * as ToggleGroup from '@radix-ui/react-toggle-group';
import classNames from 'classnames';

import { SingleCardSelectItem } from './components/SingleCardSelectItem';
import type { CardSelectProps } from './types';

import './card-select.scss';

export const CardSelect = ({
  className,
  options = [],
  optionCardSize = 'large',
  type,
  value,
  allowDeselect = true,
  onOptionSelect,
  withCursorPointer = false,
  priceSize,
  clickButtonToSelect = false,
  disabled = false,
  buttonFullWidth = false,
  onRemoveSms,
}: CardSelectProps) => {
  const topContainerClassName = classNames('payflow-ui card-select', optionCardSize, className, type);

  const innerContainerClassName = (option: CardSelectProps['options'][0]) =>
    classNames(
      'card-select-option',
      option.highlighted && 'highlighted',
      withCursorPointer && 'with-pointer',
      option.highlightedText && 'with-highlighted-text',
      options.some((o) => !!o.highlightedText) && 'highlighted-text-exists',
      type
    );

  if (clickButtonToSelect) {
    return (
      <div className={topContainerClassName} style={{ '--card-options-amount': options.length } as React.CSSProperties}>
        {options.map((option) => (
          <section key={option.id} className={innerContainerClassName(option)}>
            {option.highlightedText && (
              <div className="card-select-option__highlighted-text_container">
                <h6 className="card-select-option__highlighted-text_container_header">{option.highlightedText}</h6>
              </div>
            )}
            <SingleCardSelectItem
              option={option}
              optionCardSize={optionCardSize}
              value={value}
              onOptionSelect={onOptionSelect}
              withCursorPointer={withCursorPointer}
              priceSize={priceSize}
              clickButtonToSelect
              buttonFullWidth={buttonFullWidth}
              disabled={option.disabled || disabled}
              type={type}
              onRemoveSms={onRemoveSms}
            />
          </section>
        ))}
      </div>
    );
  }

  return (
    <ToggleGroup.Root
      className={topContainerClassName}
      value={value}
      type="single"
      onValueChange={(newValue) => {
        if (!onOptionSelect) {
          return;
        }

        if (!newValue && !allowDeselect) {
          return;
        }

        onOptionSelect(newValue);
      }}
    >
      {options.map((option) => (
        <ToggleGroup.Item
          key={option.id}
          className={innerContainerClassName(option)}
          value={option.id}
          id={option.id}
          disabled={option.disabled}
        >
          {option.highlightedText && (
            <div className="card-select-option__highlighted-text_container">
              <h6 className="card-select-option__highlighted-text_container_header">{option.highlightedText}</h6>
            </div>
          )}
          <SingleCardSelectItem
            option={option}
            optionCardSize={optionCardSize}
            value={value}
            onOptionSelect={onOptionSelect}
            withCursorPointer={withCursorPointer}
            priceSize={priceSize}
            buttonFullWidth={buttonFullWidth}
            type={type}
            onRemoveSms={onRemoveSms}
          />
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
};
